export default "__VITE_ASSET__rY6tOi1a__"